<template>
  <div class="ksm-suche__page--wrapper">
    <div class="ksm-suche__page">
      <div class="ksm-suche__content">
        <input
          type="text"
          style="width:50em; padding:5px"
          v-model="searchKeys"
          autofocus="true"
          @keydown="actionKeydown"
        />
        <button @click="searchStart" style="padding:5px">Suche</button>
        <g-loading size="mini" v-if="showLoading"></g-loading>
        <div style="padding:5px">{{resultText}}</div>
        <div v-if="resultList" style="padding:20px 0">
          <template v-for="(it,i) of resultList">
            <div class="ksm-flex-1" :key="i" style="margin-bottom:10px">
              <div style="font-weight:bold">{{it.merz.name.trim().replace('Merz','Merz ')}}</div>
              <template v-for="(it2,pi2) of it.seitenData">
                <div
                  :key="'s'+pi2"
                >{{it2.seite.name.length>20?it2.seite.name:it2.seite.name.replace(/\s/g,'')}}</div>
                <div v-for="(hl, hli) of it2.hls" :key="'h'+hli+'-'+pi2" style="padding:0 2em">
                  <a @click="toPath(it, it2, hl.key)">{{hl.type}}</a>
                  <span v-html="hl.val" class="ksm-suche-hl"></span>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postQuery } from "../api";
const getNum = d => {
  let i = parseInt(
    d.name
      .replace("/", ",")
      .split(",")[0]
      .replace(/\D*/, ""),
    10
  );
  if (isNaN(i)) {
    i = 0;
  }
  return i;
};

export default {
  name: "suche",
  data() {
    return {
      // searchKeys: "'KS übernimmt das für Merz 1 gewählte'",
      searchKeys: "",
      resultText: "",
      resultList: [],
      showLoading: false
    };
  },
  methods: {
    actionKeydown(evt) {
      if (evt.keyCode === 13) {
        this.searchStart();
      }
    },
    formatSearchKeys(key) {
      const text = [];
      if (key === undefined || key === "" || key === null) {
        return;
      }
      key = key.replace(/\"/g, "'");

      //aa "bbb bb" cc dd "eee ff" ggg
      const regex = /'[^']+'/;
      let matchRes = key.match(regex);
      //search key split
      let max = 100;
      //防止死循环
      while (matchRes && max) {
        max--;
        const idx = matchRes.index;
        if (idx > 0) {
          //前面正常的字符
          key
            .substring(0, idx)
            .trim()
            .split(" ")
            .forEach(s => {
              text.push(s.replace(/'/g, ""));
            });
        }
        text.push(matchRes[0].replace(/'/g, ""));
        key = key.substring(idx + matchRes[0].length).trim();
        matchRes = key.match(regex);
      }
      if (!key) {
        return text;
      }
      key.split(" ").forEach(w => {
        text.push(w.replace(/'/g, ""));
      });
      return text;
    },

    searchStart() {
      this.searchKeys = this.searchKeys.trim();
      this.showLoading = true;
      this.resultText = "";
      const searchKeys = this.formatSearchKeys(this.searchKeys);
      const vue = this;
      this.resultList = null;
      if (!searchKeys) {
        setTimeout(function() {
          vue.showLoading = false;
        }, 500);
        return;
      }
      const out = [];
      const seiteIdMap = this.seiteIdMap;
      postQuery("simpleSearch", {
        text: searchKeys
      }).then(res => {
        setTimeout(function() {
          vue.showLoading = false;
        }, 500);

        vue.resultList = [];
        if (!res.data) {
          return;
        }
        const allMerz = vue.allMerz;
        const merzItems = res.data
          .filter(d => d.val)
          .map(d => {
            let obj;
            let hl = d.highlight;
            const hls = [];
            Object.keys(hl).forEach(k => {
              hl[k].forEach((v, i) => {
                v = v.replace(
                  /<em>/g,
                  '<span style="background-color:yellow">'
                );
                v = v.replace(/<\/em>/g, "</span>");
                let t;
                if (k === "114_plaintext") {
                  t = "Einführung";
                } else if (k === "98_plaintext") {
                  t = "Transkription";
                } else if (k === "notes.content") {
                  t = "Einzelstellenkommentare";
                }
                hls.push({ key: k, type: t, val: "... " + v + " ..." });
              });
            });
            if (d.docTyp.id === "114") {
              const merz = allMerz.find(merz => merz.merzNameId - d.val === 0);
              if (!merz) {
                console.log("ohne Merz mit ID ", d.val);
                return;
              }
              obj = {
                hls: hls,
                seite: merz.seiten[0],
                merz: merz
              };
            } else {
              console.log(d.ID);
              console.log(seiteIdMap);
              obj = seiteIdMap[d.ID];
              console.log(obj);
              obj.hls = hls;
            }
            return obj;
          });

        const merzMap = new Map();
        merzItems.forEach(it => {
          if (!it) {
            return;
          }

          const merz = it.merz;
          const seite = it.seite;
          if (seite) {
            const sIdx = seite.idx;
            let obj = merzMap.get(merz.id);
            if (obj) {
              if (!obj.seitenData.find(d => d.seite.idx === sIdx)) {
                obj.seitenData.push({
                  seite: seite,
                  hls: it.hls
                });
              }
            } else {
              merzMap.set(merz.id, {
                merz: merz,
                seitenData: [
                  {
                    seite: seite,
                    hls: it.hls
                  }
                ]
              });
            }
          }
        });
        const resultList = [...merzMap.values()];
        resultList.sort((a, b) => {
          a = a.merz.name;
          b = b.merz.name;
          if (a.match(/\d+/) && b.match(/\d+/)) {
            a = getNum({ name: a });
            b = getNum({ name: b });
            if (a > b) {
              return 1;
            } else if (a < b) {
              return -1;
            }
            return 0;
          } else {
            return a.localeCompare(b, "de");
          }
        });
        vue.resultList = resultList;
        if (resultList.length < 1) {
          vue.resultText = "Die Suche ergibt keine Treffer.";
        }
      });
    },

    toPath(it, it2, key) {
      const query = {
        merzId: it.merz.id,
        seiteIdx: it2.seite.idx
      };
      const b_query = {
        b_merzId: it.merz.id,
        b_seiteIdx: it2.seite.idx
      };

      let useQuery;
      let path;
      let modusId;
      console.log(key);

      //vergleich b_
      if (key === "114_plaintext") {
        modusId = "ansichtsmodus";
        useQuery = query;
      } else if (key === "notes.content") {
        modusId = "untersuchungsmodus";
        useQuery = query;
      } else if (key === "98_plaintext") {
        modusId = "untersuchungsmodus";
        useQuery = query;
      }

      const merzName = it.merz.name;
      let modus;
      if (merzName.indexOf("Merz") === 0) {
        path = "/texte/merzhefte/" + modusId;
        modus = this.$store.getters["modus/getModusByIdKey"]({
          modusId: modusId,
          viewKey: "texte"
        });
      } else if (merzName === "ursonate") {
      } else {
        path = "/merzwerbe/" + modusId;
        modus = this.$store.getters["modus/getModusByIdKey"]({
          modusId: modusId,
          viewKey: "werbe"
        });
      }

      if (modusId === "untersuchungsmodus" && modus) {
        this.$store.commit("updateObjectByKey", {
          obj: modus.option,
          key: "openedAccordionId",
          val: "acco_einzelstellenkommentare"
        });
      }

      if (!path) {
        this.$router.push({
          query: useQuery
        });
      } else {
        this.$router.push({
          path: path,
          query: useQuery
        });
      }
    }
  },
  computed: {
    texte() {
      return this.$store.state.texte.merzListe;
    },
    werbe() {
      return this.$store.state.werbe.merzListe;
    },
    ursonate_noten() {
      return this.$store.state.ursonate_noten.merzListe;
    },
    ursonate_texte() {
      return this.$store.state.ursonate_texte.merzListe;
    },
    allMerz() {
      let list = [];
      const { texte, werbe, ursonate_noten, ursonate_texte } = this;
      if (texte) {
        list = list.concat(texte);
      }
      if (werbe) {
        list = list.concat(werbe);
      }
      if (ursonate_noten) {
        list = list.concat(ursonate_noten);
      }
      if (ursonate_texte) {
        list = list.concat(ursonate_texte);
      }
      return list;
    },
    seiteIdMap() {
      const list = this.allMerz;
      const seiteIdMap = {};
      list.forEach(merz => {
        merz.seiten.forEach(seite => {
          seite.seiteIds.forEach(id => {
            seiteIdMap[id] = {
              merz: merz,
              seite: seite
            };
          });
        });
      });
      return seiteIdMap;
    }
  }
};
</script>

<style lang="scss"
 scoped>
.ksm-suche__page--wrapper {
  color: #000;
  background-color: #eee;
  @extend .ksm-flex;
}

.ksm-suche__page {
  @extend .ksm-flex-1;
  position: relative;
}

.ksm-suche__content {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
  a {
    color: $blue2;
    cursor: pointer;
    &:hover {
      color: $darkRed;
    }
  }
}

.ksm-suche-hl {
}
</style>


// WEBPACK FOOTER //
// Suche.vue?2170eebc